<template>
  <div>
<h2 class="goth">Därför, därför att, för att</h2>
<div class="grammatikparagrafbredd leftorient">

<p>
Uttrycken <i>"därför, därför att, för att"</i> vållar ibland bekymmer hos svenskar som pratar tyska just därför
att DE SVENSKA uttrycken påminner om varandra till utseendet även om de
används i olika sammanhang.
</p>

<br>
<h4>därför</h4>


<p>
<i>Därför</i> används när man hört ett argument / en orsak tidigare
i samtalet/sammanhanget, men nu kommer till konsekvensen. Den nämns efter ordet <i>därför</i>. </p>


<br>
<div class="ruta">
<p><i>Det regnar. <b>Därför</b> måste jag använda mitt paraply.<br>
    Es regnet. <b>Deshalb</b> muss ich meinen Regenschirm benutzen.</i></p>
</div>
<br>

<p>På tyska finns här några olika ord att välja bland: <i><b>deshalb, deswegen, darum</b></i>.
    Orden brukar inleda en ny huvudsats.</p>

<p class="mindre"><i>Därför</i> har dock INTE samma betydelse som det tyska <i><strike>dafür</strike></i>.
    Det sistanämnda betyder snarare <i>för det…, för den..</i> eller <i>istället…, å andra sidan…</i>
    och det är ytterst ovanligt att det ordet i ett sammanhang motsvarar <i>därför</i> på svenska.</p>


    <br>
    <h4>därför att, eftersom</h4>



    <p>I de fall man på svenska kan säga <i>därför att</i>, eller utan större omskrivning
        <i>eftersom</i>, används på tyska <i><b>weil</b></i>, som inleder en bisats.</p>


<p><i>därför att, eftersom</i> används före argumentet eller orsaken.</p>

<div class="ruta">
    <p><i>Jag köpte en katt <b>eftersom</b> jag gillar djur.<br>
        Ich kaufte eine Katze, <b>weil</b> ich Tiere mag.</i></p>


    <p><i>Varför sjunger du? <b>Därför att</b> jag har lust.<br>
        Warum singst du? <b>Weil</b> ich Lust habe.</i></p>

</div>
<br><br>
    <h4>för att...</h4>



    <p>Uttrycket <i>för att</i> ger en förklaring till en handling men inleder
        ingen fullständig bisats utan bara ett verb i infinitiv. På tyska motsvarar detta en
    konstruktion med <i><b>um .. zu ..</b></i>. Den kallas ibland för "um-zu-konstruktion".</p>



<div class="ruta">
    <p><i>Jag åker till stan <b>för att</b> köpa kläder.<br>
        Ich fahre in die Stadt, <b>um </b> Kleider <b>zu</b> kaufen.</i></p>
    </div>

<br>
<br>


<p>För att komplicera det hela ytterligare kan man på svenska ibland <i>för att</i>,
    när man kunde sagt <i>därför att</i>.
    I de fall skall <i>weil</i> användas.
    <i>um .. zu ..</i> används när man INTE kan säga <i>därför att</i> utan bara <i>för att</i>.</p>
    <p class="mindre">(I meningen <i>"Jag åker till stan för att köpa kläder."</i> kan man INTE säga <i>"<strike>Jag åker till stan därför att köpa kläder.</strike>"</i>)
</p>
<div class="ruta">
<p><i>Jag ljuger <b>[där]för att</b> jag inte får säga sanningen. <br>Ich lüge, <b>weil</b> ich die Wahrheit nicht sagen darf.</i></p>
</div>
<br><br><br>

</div>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "därför att um..zu weil deshalb deswegen darum"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

th {
    font-weight: bold;
}
</style>
